<template>
  <div class="app-container">
    <BjDivider right-fixed>{{ $t('goodsSku.package.BasicInformation') }}
      <template slot="right" right-fixed>
        <template>
          <el-button v-if="isEdit || isAdd" @click="tryCancel">{{ $t('cancelText') }}</el-button>
          <el-button v-if="isEdit || isAdd" v-permission:BusinessGoodsSkuOrdinary_Audit type="primary" @click="handleConfirm(false)">{{ $t('saveText') }}</el-button>
        </template>
        <template v-if="isView">
          <el-button type="primary" @click="cancel">{{ $t('backText') }}</el-button>
        </template>
      </template>
    </BjDivider>

    <el-form ref="form" :model="goodsData" :rules="rules" label-width="230px" class="form">
      <el-row>
        <el-col v-if="isEdit || isView" :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.ProductClassification')" prop="categoryName">
            {{ goodsData.categoryName }}
          </el-form-item>
        </el-col>
        <el-col v-else :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.ProductClassification')" prop="categoryId">
            <BjGoodsTypeTreeSelect ref="BjGoodsTypeTreeSelect" v-model="goodsData.categoryId" :disabled="isView" @change="changeCategory" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.package.packageName')" prop="skuName">
            <BjInput v-model="goodsData.skuName" :disabled="isView" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.package.packageSkuCode')" prop="skuCode">
            <BjInput v-model="goodsData.skuCode" :disabled="isEdit || isView" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col v-if="isEdit || isView" :span="colSpan">
          <el-form-item :label="$t('goodsSku.package.costPrice')" prop="costPrice">
            <BjInput v-model="goodsData.costPrice" disabled :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col v-else :span="colSpan">
          <el-form-item :label="$t('goodsSku.package.costPrice')" prop="costPrice">
            <BjInput v-model="itemType" disabled :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.package.salesPrice')" prop="salesPrice">
            <BjInputMoney v-model="goodsData.salesPrice" :disabled="isView" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>

        <BjDivider>{{ $t('goodsSku.package.packageProductMsg') }}
          <template>
            <el-button type="primary" :disabled="isEdit || isView" @click="onDelete">{{ $t('goodsSku.package.delete') }}SKU</el-button>
            <el-button type="primary" :disabled="isEdit || isView" @click="onAddSkuDetail">{{ $t('addText') }}SKU</el-button>
          </template>
        </BjDivider>
        <el-table ref="storeTable" :data="goodsData.skuDetailList" stripe border :header-cell-style="$rowStyle.DEFAULT" @selection-change="onSelections">
          <el-table-column align="center" type="index" :label="$t('table.countText')" width="65" />
          <el-table-column align="center" prop="itemId" type="selection" />
          <el-table-column align="center" prop="skuCode" label="SKU"></el-table-column>
          <el-table-column align="center" prop="skuName" :label="$t('goodsSku.package.skuName')"></el-table-column>
          <el-table-column align="center" prop="costPrice" :label="$t('goodsSku.package.costPrice')"></el-table-column>
          <el-table-column align="center" prop="salesPrice" :label="$t('goodsSku.package.salesPrice')"></el-table-column>
          <el-table-column align="center" prop="num" :label="$t('goodsSku.package.Qty')">
            <template slot-scope="scope">
                <BjInput v-model="scope.row.num" oninput="value=value.replace(/[^\d]/g,'')" :disabled="isView || isEdit" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable />
            </template>
          </el-table-column>
          <el-table-column prop="action" :label="$t('operationText')" align="center">
            <template slot-scope="scope">
              <el-button type="text" :disabled="isView || isEdit" @click="goodsData.skuDetailList.splice(scope.$index,1)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-form>

    <!-- SKU -->
    <BjDialogList
      ref="skuDialogList"
      :config="$BjDialogListConfig.skuDefault()"
      multiple
      @confirm="onConfirmSkuDialogList"
    />
  </div>
</template>
<script>
import {goodsApi} from '@/api';
import viewMiXin from '@/utils/view-mixin';

export default {
  mixins: [viewMiXin],
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    isView: {
      type: Boolean,
      default: false,
    },
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      colSpan: 8,
      goodsData: {
        id: this.$route.query.id || null,
        skuCode: '',
        skuName: '',
        costPrice: 0,
        categoryId: null,
        categoryName: '',
        salesPrice: '',
        skuDetailList: [],

        itemType: '',
        categoryIdList: [],
        barCode: '',
        vendor: '',
        buying_dep: '',
        buyingDep: '',
        buyerName: '',
        brand: '',
        cartonBoxBarcode: '',
        seasonalGoods: 'AllSeas',
        merchandiser: '',
        activityPrice: null,
        marketPrice: null,
        distributionPrice: null,
        wholesalePrice: null,
        clearingPrice: null,
        discontinued: true,
        inventoryItem: true,
        purchaseItem: true,
        salesItem: true,
        fragile: 0,
        dangerousGoods: false,
        flammable: false,
        imageUrl: '',
        skuLicenseList: [],
        length: null,
        width: null,
        height: null,
        weight: null,
        qty: null,
        cartonLength: null,
        cartonWidth: null,
        cartonHeight: null,
        cartonWeight: '',
      },
        selections: [],
      rules: {
        categoryId: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        categoryName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        skuName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        skuCode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        salesPrice: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
    };
  },
  computed: {
    itemType() {
      if (this.isAdd) {
        return this.goodsData.skuDetailList.reduce((pre, item) => {
          pre += item.costPrice * item.num;
          return pre;
        }, 0);
      }
      return 0;
    }
  },
  watch: {
    itemType(val) {
      if (this.isAdd) {
        this.goodsData.costPrice = val;
      }
    }
  },
  created() {
    if (this.isEdit || this.isView) {
      this.getGoodsDetailData();
    }
  },
  methods: {
    changeCategory(item) {
      if (!item?.label) return;
      this.goodsData.categoryName = item.label;
    },
    async getGoodsDetailData() {
      this.goodsData = await goodsApi.detailSku({id: this.$route.query.id});
    },
    onConfirmSkuDialogList(data) {
      if (this.goodsData.skuDetailList.length > 0) {
        const dataList = data.filter(item => !this.goodsData.skuDetailList.some(v => v.skuCode === item.skuCode)).map(item => {
          return {...item, num: 1};
        });
        this.goodsData.skuDetailList = [...this.goodsData.skuDetailList, ...dataList];
      } else {
        this.goodsData.skuDetailList = data.map(item => {
          return {...item, num: 1};
        });
      }
    },
    onAddSkuDetail() {
      this.$refs.skuDialogList.show();
    },
    onDelete() {
      if (this.selections.length) {
        this.goodsData.skuDetailList = this.goodsData.skuDetailList.filter(item => this.selections.indexOf(item) === -1);
        this.goodsData.selections = [];
      }
    },
    onSelections(val) {
      this.selections = val;
    },
    handleConfirm(flag) {
      this.$refs.form.validate(valid => {
        if (valid) {
          let obj = null;
          if (this.isEdit) {
             obj = this.goodsData;
            goodsApi.updateSku({
              flag,
              sku: {...obj}
            }).then(res => {
              if (!res.failed) {
                this.msgSuccess(this.$t('toast.operationSuccessText'));
               setTimeout(() => {
                 this.$router.replace('/business/goods/sku/package');
               }, 500);
              }
            });
          } else {
            if (!this.goodsData.skuDetailList.length > 0) {
              this.msgError(this.$t('goodsSku.package.msgErrorText'));
              return false;
            }
            const finalList = this.goodsData.skuDetailList.map(item => {
              return {
                num: item.num ? Number(item.num) : 1,
                packageSkuId: item.id,
                id: null,
                skuId: null
              };
            });
             obj = {
               ...this.goodsData,
              skuCode: this.goodsData.skuCode,
              skuName: this.goodsData.skuName,
              costPrice: this.goodsData.costPrice,
              salesPrice: this.goodsData.salesPrice,
              skuDetailList: finalList
            };
             goodsApi.addSku({
              flag,
              setFlag: 1, // 0-单品，1-套餐
              skuList: [obj]
            }).then(res => {
              if (!res.failed) {
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                this.goodsData = {
                  ...this.goodsData,
                  skuCode: '',
                  skuName: '',
                  costPrice: 0,
                  categoryId: null,
                  categoryName: '',
                  salesPrice: '',
                  skuDetailList: [],
                };
                setTimeout(() => {
                  this.$router.replace('/business/goods/sku/package');
                }, 500);
              }
            });
          }
        }
      });
    },
  },
};
</script>
<style>
</style>
